// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5df1631b","455":"b0bb97e8","977":"2dc5d7f2"}[chunkId] + ".chunk.js";
};